import "./styles/fixed-navigation.css";
import "./styles/contained-controls.css";
import "../../shared/academy-brand.css";
import React from "react";
import ChatonerAIInstructorStudio from "./App";
import { mountFrontend } from "./app/bootstrap";
import { APP_ID } from "./config/environment";
import { AppErrorBoundary } from "./components/AppErrorBoundary";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Chatoner AI Academy could not find the #root mount element.");
}

void mountFrontend(
  root,
  <AppErrorBoundary>
    <ChatonerAIInstructorStudio />
  </AppErrorBoundary>,
  APP_ID,
);
